import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Saulo Pratti
 * id 39D66F7E-C38A-4CDC-9A50-6C4A60F70B82
 * name view-gallery
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-gallery.svg
 * tags
 * - View 
 */
export const ViewGalleryIcon = createSvgIcon(<><path d="M21 3H2V16H21V3M2 17H6V21H2V17M7 17H11V21H7V17M12 17H16V21H12V17M17 17H21V21H17V17Z" /></>, 'ViewGalleryIcon');
export default ViewGalleryIcon